import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';

const useStyles = makeStyles(theme => ({
  root: {
    // maxWidth: 400,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default
  }
}));

export default function DotStepper (props) {
  const classes = useStyles();

  const { activeStep, numOfSteps } = props;

  return (
    <MobileStepper
      variant='dots'
      steps={numOfSteps}
      position='static'
      activeStep={activeStep}
      className={classes.root}
    />
  );
}
